import React from "react";
interface MetricsData {
    totalActive: number;
    totalDiscountAvailable: number;
    totalUpcoming: number;
    totalExpired: number;
    totalPending: number;
  }

interface MetricsProps {
  metrics: MetricsData;
}
const DiscountCard: React.FC<MetricsProps> = ({ metrics }) => {
  return (
    <div className="my-7">
      <div className="flex lg:grid lg:grid-cols-5 gap-4 overflow-x-auto scrollbar-hide lg:overflow-visible whitespace-nowrap">
        <section className="bg-white border border-[#C9C9C9] rounded-3xl p-4 flex flex-col justify-between">
          <p className="font-bold text-[14px] text-[#475467]">
            Total Discount
            <button type="button"></button>
          </p>
          <h1 className="text-[#2B2B2B] text-[36px] font-extrabold">
            {metrics?.totalDiscountAvailable || 0}
          </h1>
        </section>
        <section className="bg-white border border-[#C9C9C9] rounded-3xl p-4 flex flex-col justify-between">
          <p className="font-bold text-[14px] text-[#475467]">
            Total Active Discount
            <button type="button"></button>
          </p>
          <h1 className="text-[#2B2B2B] text-[36px] font-extrabold">
            {metrics?.totalActive || 0}
          </h1>
        </section>

        {/* Orders Card */}
        

        {/* Withdrawals Card */}
        <section className="bg-white border border-[#C9C9C9] rounded-3xl p-4 flex flex-col justify-between">
          <p className="font-bold text-[14px] text-[#475467]">
            Upcoming Discount
            <button type="button"></button>
          </p>
          <h1 className="text-[#2B2B2B] text-[36px] font-extrabold">
            {" "}
            {metrics?.totalUpcoming || 0}
          </h1>
        </section>
        <section className="bg-white border border-[#C9C9C9] rounded-3xl p-4 flex flex-col justify-between">
          <p className="font-bold text-[14px] text-[#475467]">
            Pending Discount
            <button type="button"></button>
          </p>
          <h1 className="text-[#2B2B2B] text-[36px] font-extrabold">
            {" "}
            {metrics?.totalPending || 0}
          </h1>
        </section>
        {/* Out Escrow Card */}

        <section className="bg-white border border-[#C9C9C9] rounded-3xl p-4 flex flex-col justify-between">
          <p className="font-bold text-[14px] text-[#475467]">
            Expired Discount
            <button type="button"></button>
          </p>
          <h1 className="text-[#2B2B2B] text-[36px] font-extrabold">
            {metrics?.totalExpired|| 0}
          </h1>
        </section>
      </div>
    </div>
  );
};

export default DiscountCard;
